var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoPwc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_41",
    "data-name": "Group 41",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 76,
    height: 58.338,
    viewBox: "0 0 76 58.338",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_33",
    "data-name": "Rectangle 33",
    width: 76,
    height: 58.338,
    fill: "#2b400f"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M.059,182.265l1.673-.147.323-.382V165.625H0v-1.409l5.429-1.732H6.956v1.966c2.7-1.585,3.757-2,5.136-2,3.228,0,5.694,3.052,5.694,7.073,0,4.7-3.375,7.836-8.364,7.836-.587,0-1.526-.059-2.465-.147v4.519l.381.382,1.937.147-.059,1.555H.059Zm6.9-6.721a4.331,4.331,0,0,0,.792.059c3.023,0,4.637-1.878,4.637-5.4,0-2.993-1.321-4.578-3.757-4.578a11.513,11.513,0,0,0-1.673.147Z",
    transform: "translate(0 -125.482)",
    fill: "#2b400f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M83.262,162.543a14.85,14.85,0,0,1,.381,2.495l.323,7.161,4.285-8.1v-.851l4.432-.352.558,11.152,3.786-5.253-.822-5.4a3,3,0,0,1,2.26-.939,2.22,2.22,0,0,1,2.407,2.289c0,1.438-.792,3.14-2.759,5.869-.616.851-2.436,3.111-5.429,6.75H89.22l-.675-10.1-5.488,10.1H79.33l.294-1.321-.47-10.624-2.906-.47v-1.174l5.312-1.233Z",
    transform: "translate(-58.895 -125.482)",
    fill: "#2b400f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M193.445,164.04c-2.495.381-3.786,2.23-3.786,5.429,0,3.229,1.732,5.371,4.314,5.371,1.233,0,2.348-.382,4.637-1.5v2.612a14.382,14.382,0,0,1-6.662,1.643,7.243,7.243,0,0,1-5.547-2.054,7.373,7.373,0,0,1-2.142-5.341c0-4.608,3.463-7.748,8.54-7.748,3.375,0,5.694,1.526,5.694,3.727a2.435,2.435,0,0,1-2.7,2.436,4.342,4.342,0,0,1-2.348-.7Z",
    transform: "translate(-142.324 -125.482)",
    fill: "#2b400f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21",
    "data-name": "Rectangle 21",
    width: 14.357,
    height: 3.787,
    transform: "translate(34.112 24.929)",
    fill: "#2b400f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22",
    "data-name": "Rectangle 22",
    width: 14.041,
    height: 2.999,
    transform: "translate(48.469)",
    fill: "#2b400f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23",
    "data-name": "Rectangle 23",
    width: 2.604,
    height: 4.337,
    transform: "translate(62.511 2.999)",
    fill: "#2b400f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24",
    "data-name": "Rectangle 24",
    width: 14.041,
    height: 4.337,
    transform: "translate(48.469 2.999)",
    fill: "#2b400f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25",
    "data-name": "Rectangle 25",
    width: 7.1,
    height: 10.729,
    transform: "translate(65.115 7.336)",
    fill: "#2b400f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26",
    "data-name": "Rectangle 26",
    width: 2.604,
    height: 10.729,
    transform: "translate(62.511 7.336)",
    fill: "#2b400f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M221.647,42.965h5.364V32.235H212.97v7.179h8.677Z",
    transform: "translate(-164.5 -24.899)",
    fill: "#2b400f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27",
    "data-name": "Rectangle 27",
    width: 3.785,
    height: 6.863,
    transform: "translate(72.215 18.066)",
    fill: "#2b400f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28",
    "data-name": "Rectangle 28",
    width: 7.1,
    height: 6.863,
    transform: "translate(65.115 18.066)",
    fill: "#2b400f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29",
    "data-name": "Rectangle 29",
    width: 2.604,
    height: 6.863,
    transform: "translate(62.511 18.066)",
    fill: "#2b400f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    width: 5.364,
    height: 6.863,
    transform: "translate(57.147 18.066)",
    fill: "#2b400f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31",
    "data-name": "Rectangle 31",
    width: 8.677,
    height: 3.55,
    transform: "translate(48.469 14.516)",
    fill: "#2b400f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32",
    "data-name": "Rectangle 32",
    width: 8.677,
    height: 6.863,
    transform: "translate(48.469 18.066)",
    fill: "#2b400f"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPwc);
export default __webpack_public_path__ + "static/media/logo-pwc.8769bfd01fcc7ba885e817aa901f62f3.svg";
export { ForwardRef as ReactComponent };